var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h6',[_vm._v("unavailable view")])
}
var staticRenderFns = []

export { render, staticRenderFns }